export const LogoMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="20" cy="20" r="18" stroke="url(#crednova-gold-grad)" strokeWidth="2" />
    <path
      d="M25 14C23.5 12.5 21.5 12 19 12C14.5 12 11 15.5 11 20C11 24.5 14.5 28 19 28C21.5 28 23.5 27.5 25 26"
      stroke="url(#crednova-gold-grad)"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M22 20L25 23L31 16"
      stroke="#F3E5AB"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="crednova-gold-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#BF953F" />
        <stop offset="0.3" stopColor="#FCF6BA" />
        <stop offset="0.6" stopColor="#B38728" />
        <stop offset="1" stopColor="#AA771C" />
      </linearGradient>
    </defs>
  </svg>
);
